if (!customElements.get("m-hotspot")) {
  class Hotspot extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        wrapper: ".m-hotspots-image__wrapper",
        card: ".m-hotspot__card",
      };

      this.domNodes = queryDomNodes(this.selectors, this)
      this.wrapper = this.closest(this.selectors.wrapper)
      this.card = this.domNodes.card

      this.init()
      document.addEventListener("matchMobile", () => {
        this.init()
      });
      document.addEventListener("unmatchMobile", () => {
        this.init()
      });
      this.addEventListener('mouseover', this.init.bind(this))
    }

    disconnectedCallback() {
      this.removeEventListener('mouseover', this.init.bind(this))
    }

    init() {
      this.wrapperOffsetX = this.wrapper.getBoundingClientRect().left
      this.wrapperOffsetY = this.wrapper.getBoundingClientRect().top

      this.offsetX = this.getBoundingClientRect().left - this.wrapperOffsetX
      this.offsetY = this.getBoundingClientRect().top - this.wrapperOffsetY

      this.width = this.clientWidth
      this.cardWidth = this.card.clientWidth
      this.cardHeight = this.card.clientHeight
      this.wrapperWidth = this.wrapper.clientWidth
      this.wrapperHeight = this.wrapper.clientHeight

      this.cardPosition = this.offsetY > this.cardHeight ? 'top' : 'bottom'

      if ((this.offsetX + this.width) > this.cardWidth) {
        this.cardPosition += '-left'
      } else if ((this.wrapperWidth - this.offsetX) > this.cardWidth) {
        this.cardPosition += '-right'
      }

      this.dataset.cardPosition = this.cardPosition

      switch (this.cardPosition) {
        case 'top-left':
          this.card.style.bottom = 'calc(100% + 20px)'
          this.card.style.right = '-20px'
          this.card.style.top = 'auto'
          this.card.style.left = 'auto'
          this.card.style.marginLeft = '0px'
          break;
        case 'top-right':
          this.card.style.bottom = 'calc(100% + 20px)'
          this.card.style.left = '-20px'
          this.card.style.top = 'auto'
          this.card.style.right = 'auto'
          this.card.style.marginLeft = '0px'
          break;
        case 'bottom-left':
          this.card.style.top = 'calc(100% + 20px)'
          this.card.style.right = '-20px'
          this.card.style.bottom = 'auto'
          this.card.style.left = 'auto'
          this.card.style.marginLeft = '0px'
          break;
        case 'bottom-right':
          this.card.style.top = 'calc(100% + 20px)'
          this.card.style.left = '-20px'
          this.card.style.bottom = 'auto'
          this.card.style.right = 'auto'
          this.card.style.marginLeft = '0px'
          break;
        case 'bottom':
          this.card.style.top = 'calc(100% + 20px)'
          this.card.style.left = '50%'
          this.card.style.bottom = 'auto'
          this.card.style.right = 'auto'
          this.card.style.marginLeft = `${-1 * this.cardWidth / 2}px`
          break;
        case 'top':
          this.card.style.bottom = 'calc(100% + 20px)'
          this.card.style.left = '50%'
          this.card.style.top = 'auto'
          this.card.style.right = 'auto'
          this.card.style.marginLeft = `${-1 * this.cardWidth / 2}px`
          break;
        default:
      }

      // COUNTERPOINT, 20 Aug 2026 (rev 2, supersedes the viewport clamp): on
      // small screens the card sits dead centre of its own image block, both
      // axes, whichever marker opened it. The switch above anchors the card to
      // the marker and never checks the block or viewport bounds, so on
      // mobile a card could run off the right edge and hang below its block
      // over the section underneath. The card is capped to the block bounds
      // with an internal vertical scroll for copy taller than the block.
      // Desktop (above 799px) keeps the stock marker-anchored placement, and
      // the mobile-only inline caps are cleared when leaving mobile.
      if (this.card) {
        if (window.matchMedia('(max-width: 799px)').matches) {
          const gutter = 16
          const wrapRect = this.wrapper.getBoundingClientRect()
          const markRect = this.getBoundingClientRect()
          this.card.style.maxWidth = `${wrapRect.width - 2 * gutter}px`
          this.card.style.maxHeight = `${wrapRect.height - 2 * gutter}px`
          this.card.style.overflowY = 'auto'
          const cardW = this.card.offsetWidth
          const cardH = this.card.offsetHeight
          this.card.style.left = `${wrapRect.width / 2 - (markRect.left - wrapRect.left) - cardW / 2}px`
          this.card.style.top = `${wrapRect.height / 2 - (markRect.top - wrapRect.top) - cardH / 2}px`
          this.card.style.right = 'auto'
          this.card.style.bottom = 'auto'
          this.card.style.marginLeft = '0px'
          this.card.style.marginRight = '0px'
        } else {
          this.card.style.maxWidth = ''
          this.card.style.maxHeight = ''
          this.card.style.overflowY = ''
          this.card.style.marginRight = ''
        }
      }
    }
  }
  customElements.define("m-hotspot", Hotspot);
}